import { BookWidgetFields } from '@com-delta-idp/mnx-capability-flight-shop-ui';

export const flexAirportRulesOnInitEval = (
  bookWidgetFields: BookWidgetFields
): BookWidgetFields => {
  let updatedBookWidgetFields = { ...bookWidgetFields };

  if (updatedBookWidgetFields.flexAirportsField.checked) {
    updatedBookWidgetFields = {
      ...updatedBookWidgetFields,
      flexDatesField: {
        ...updatedBookWidgetFields.flexDatesField,
        disable: true,
        checked: false
      }
    };
  }

  return updatedBookWidgetFields;
};
